/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Conflict,
  DataImportRetrieveModel,
  Forbidden,
  NotFound,
  Unauthorized,
  WorkItemModel,
} from '../models';

export interface DataImportAddImportDataBySiteIdRequest {
    siteId: string;
    dataImportRetrieveModel: DataImportRetrieveModel;
}

export interface DataImportGetImportBySiteIdRequest {
    siteId: string;
    configId?: string;
    action?: string;
}

/**
 * 
 */
export class DataImportApi extends runtime.BaseAPI {

    /**
     * Adds a data import work item to the processing queue for a specific site. Triggers re-import of energy data from external sources using specified configuration and action type. Useful for data recovery, synchronization, or historical data backfill
     * Queue Site Data Re-import
     */
    async dataImportAddImportDataBySiteIdRaw(requestParameters: DataImportAddImportDataBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
            throw new runtime.RequiredError('siteId','Required parameter requestParameters.siteId was null or undefined when calling dataImportAddImportDataBySiteId.');
        }

        if (requestParameters.dataImportRetrieveModel === null || requestParameters.dataImportRetrieveModel === undefined) {
            throw new runtime.RequiredError('dataImportRetrieveModel','Required parameter requestParameters.dataImportRetrieveModel was null or undefined when calling dataImportAddImportDataBySiteId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/data-import/site/{siteId}`.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters.siteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.dataImportRetrieveModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a data import work item to the processing queue for a specific site. Triggers re-import of energy data from external sources using specified configuration and action type. Useful for data recovery, synchronization, or historical data backfill
     * Queue Site Data Re-import
     */
    async dataImportAddImportDataBySiteId(requestParameters: DataImportAddImportDataBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dataImportAddImportDataBySiteIdRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all data import work items for a specific site/installation. Returns import history including timestamps, configurations, actions, and processing status. Supports optional filtering by configuration ID and action type for targeted queries
     * Get List of Import Work Items
     */
    async dataImportGetImportBySiteIdRaw(requestParameters: DataImportGetImportBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkItemModel>>> {
        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
            throw new runtime.RequiredError('siteId','Required parameter requestParameters.siteId was null or undefined when calling dataImportGetImportBySiteId.');
        }

        const queryParameters: any = {};

        if (requestParameters.configId !== undefined) {
            queryParameters['configId'] = requestParameters.configId;
        }

        if (requestParameters.action !== undefined) {
            queryParameters['action'] = requestParameters.action;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/data-import/site/{siteId}`.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters.siteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all data import work items for a specific site/installation. Returns import history including timestamps, configurations, actions, and processing status. Supports optional filtering by configuration ID and action type for targeted queries
     * Get List of Import Work Items
     */
    async dataImportGetImportBySiteId(requestParameters: DataImportGetImportBySiteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkItemModel>> {
        const response = await this.dataImportGetImportBySiteIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
